module.exports = __webpack_public_path__ + "static/media/icon_inbox_solicitudcontrato.a2f832e9.svg";